export const mapBadgeType = product => {
  if (
    product.productType === "MixMatchGroup" ||
    product.productType === "MixMatchProduct"
  ) {
    return "MixMatch";
  } else if (product.hasVariantColours) {
    return "MoreColors";
  }

  return null;
};
